// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__v04cR","list":"style_list__Vdpwu","column":"style_column__8Tw20","item":"style_item__GRfg_","showMore":"style_showMore__AqKPp"};